import React from 'react';
import { useTranslation } from 'react-i18next';

import ErrorState from '../ErrorState/ErrorState';

const NotFound = ({ isAuthenticated = false }) => {
  const { t } = useTranslation();
  const destination = isAuthenticated ? '/' : '/login';
  const label = isAuthenticated ? t('errorPages.backToHome') : t('errorPages.backToLogin');

  return (
    <ErrorState
      code="404"
      title={t('errorPages.notFoundTitle')}
      description={t('errorPages.notFoundDescription')}
      actionTo={destination}
      actionLabel={label}
      tone="cyan"
    />
  );
};

export default NotFound;
